import React, { createContext, useEffect, useState, useContext, useCallback } from "react";
import LogoLoader from "../components/Common/LogoLoader";

const API = process.env.REACT_APP_AUTH_API
  ? process.env.REACT_APP_AUTH_API.replace("/api/auth", "/api")
  : "/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [questionTypes, setQuestionTypes] = useState([]);

  const fetchMyPlan = useCallback(async () => {
    try {
      const res = await fetch(`${API}/plans/my-plan`, { credentials: "include" });
      if (res.ok) {
        const data = await res.json();
        setQuestionTypes(data.questionTypes || []);
      }
    } catch {}
  }, []);

  const fetchMe = useCallback(async () => {
    try {
      const res = await fetch(`${API}/auth/me`, { credentials: "include" });
      if (res.ok) {
        const data = await res.json();
        const u = data.user || data;
        const userObj = { ...u, _id: u._id || u.id };
        setUser(userObj);
        localStorage.setItem("user", JSON.stringify(userObj));
        localStorage.setItem("userId", userObj._id);
        await fetchMyPlan();
        return true;
      }
    } catch {}
    return false;
  }, [fetchMyPlan]);

  useEffect(() => {
    (async () => {
      const cookieOk = await fetchMe();
      if (cookieOk) {
        setLoading(false);
        return;
      }

      const storedUser = localStorage.getItem("user");
      try {
        if (storedUser && storedUser !== "undefined") {
          const parsed = JSON.parse(storedUser);
          if (parsed._id) {
            setUser(parsed);
          }
        }
      } catch (err) {
        console.error("Invalid user data in localStorage:", err);
        localStorage.removeItem("user");
      }

      setLoading(false);
    })();
  }, [fetchMe]);

  const login = (userData) => {
    const userInfo = userData.user || userData;
    const flat = {
      _id: userInfo._id || userInfo.id,
      email: userInfo.email,
      fullName: userInfo.fullName,
      role: userInfo.role,
      plan: userInfo.plan || null,
      planLimits: userInfo.planLimits || null,
      emailVerified: userInfo.emailVerified,
      isTrial: userInfo.isTrial || false,
      trialEndsAt: userInfo.trialEndsAt || null,
    };
    setUser(flat);
    localStorage.setItem("user", JSON.stringify(flat));
    localStorage.setItem("userId", flat._id);
    fetchMyPlan();
  };

  const logout = async () => {
    try {
      await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
    } catch {}
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    localStorage.removeItem("userRole");
    setUser(null);
    setQuestionTypes([]);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, questionTypes, fetchMe }}>
      {loading ? <LogoLoader /> : children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
